import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Entity} from '../entity/entity';
import {StockUnit} from '../products/stock-unit';
import {StockQuoteRequest} from '../products/stock-quote-request';
import {StockLineSpecification} from '../products/stock-line-specification';
import {GoogleService} from './google-service';
import {BrandID} from '../enums/brand-id';

@Service()
export class StockUnitService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);

  private urlBase = environment.serviceUrl;

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public getStockUnits(classCode: string, brandID: BrandID): Observable<StockUnit[]> {
    const url = this.urlBase + 'products/stockUnits/' + classCode + '/' + brandID;
    return this.http.get<StockUnit[]>(url, {headers: this.getRequestHeaders()});
  }

  public createStockQuote(request: StockQuoteRequest): Observable<Entity> {
    const url = this.urlBase + 'quotes/createStockQuote';
    const body = JSON.stringify(request);
    return this.http.post<Entity>(url, body, {headers: this.getPostHeaders()});
  }

  public getLineSpecifications(entityId: string, revision: number, lineId: string): Observable<StockLineSpecification[]> {
    const url = this.urlBase + 'stock/lineSpecs/' + entityId + '/' + revision + '/' + lineId;
    return this.http.get<StockLineSpecification[]>(url, {headers: this.getRequestHeaders()});
  }

}
